import cn from 'classnames';
import * as React from 'react';
import { connect } from 'react-redux';

import { SearchFormState } from '../../../store/reducers';
import { isMultiCity } from '../../../store/segments/selectors';
import Passengers from '../Passengers/Passengers';
import StartSearch from '../StartSearch/StartSearch';
import { useTheme } from '../../../../theme';
import { useConfig } from '../../../../context';
import Currency from '../Currency/Currency';
import { useIsWithSelectableCurrencies } from '../hooks';
import { useRenderers } from '../../../../renderProps';

const AdvancedPassengers = React.lazy(() => import('../AdvancedPassengers/AdvancedPassengers'));

interface StateProps {
	isMultiCity: boolean;
}

const Controls: React.FunctionComponent<StateProps> = React.memo(props => {
	const { Controls: css } = useTheme('SearchForm');
	const {
		SearchFormPassengers: SearchFormPassengersOverride = Passengers,
		SearchFormCurrency: SearchFormCurrencyOverride = Currency
	} = useRenderers();

	const {
		SearchForm: { proMode, startSearchButtonMode }
	} = useConfig();

	const withSelectableCurrencies = useIsWithSelectableCurrencies();

	return (
		<div
			className={cn(css.controls, {
				[css.controls_multiCity]: props.isMultiCity,
				[css.controls_advanced]: proMode,
				[css.controls_withCurrency]: withSelectableCurrencies
			})}
		>
			{proMode ? (
				<React.Suspense fallback="Loading...">
					<AdvancedPassengers />
				</React.Suspense>
			) : (
				<SearchFormPassengersOverride />
			)}
			{withSelectableCurrencies && <SearchFormCurrencyOverride />}
			<StartSearch mode={startSearchButtonMode === 'text' ? 'text' : 'icon'} />
		</div>
	);
});

const mapStateToProps = (state: SearchFormState): StateProps => {
	return {
		isMultiCity: isMultiCity(state)
	};
};

export default connect(mapStateToProps)(Controls);
